import { config } from '@cfg';

class statAPI {
  root: this;
  private _url: string;

  constructor(url = config.statsApiBaseUrl) {
    this.root = this;
    this._url = url;
  }
  async getStatsData() {
    let res = await get(`${this._url}/companies/info`);
    return res;
  }
}

const get = async (url) => {
  try {
    const res = await fetch(url, {});
    if (!res.ok) throw new Error(`HTTP error ${res.status}: ${res.statusText}`);
    return res.json();
  } catch (err) {
    return err;
  }
};

export default statAPI;
